module.exports = __webpack_public_path__ + "media/images/sp/articles/concept-efa7a2f06cc441b053348986456d6e82.webp";